import React, { Component } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import compose from 'lodash.flowright';

const FETCH_GET_SUBJECTS = gql`
  query ($student_user_exam_id: Int!) {
    getSubjects(student_user_exam_id: $student_user_exam_id) {
      id
      subject
      studentChapters {
        id
        chapter
      }
    }
  }
`;

const CREATE_DOUBT_MUTATION = gql`
  mutation($params: DoubtInput!) {
    createDoubt(params: $params)
  }
`;

const FETCH_LECTURERS_BY_SUBJECT = gql`
  query($subject_id: Int!, $institution_id: Int!) {
    getLecturersBySubject(subject_id: $subject_id, institution_id: $institution_id) {
      id
      employee_name
    }
  }
`;

const FILE_UPLOAD_MUTATION = gql`
  mutation($params: FileUploadInput!) {
    fileUpload(params: $params) {
      file_url
      uuid
    }
  }
`;

class CreateDoubtForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            chapter: '',
            assignedFacultyId: '',
            lecturersList: [],
            title: '',
            description: '',
            file: null,
            submitting: false,
            validated: false,
            errorMsg: '',
            successMsg: '',
            fileError: '',
            filePreviewUrl: ''
        };
    }

    componentWillUnmount() {
        if (this.state.filePreviewUrl) {
            URL.revokeObjectURL(this.state.filePreviewUrl);
        }
    }

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name === 'subject') {
            this.setState({ chapter: '', assignedFacultyId: '', lecturersList: [] });
            this.fetchLecturers(e.target.value);
        }
    }

    fetchLecturers = async (subjectId) => {
        if (!subjectId) return;
        try {
            const res = await this.props.client.query({
                query: FETCH_LECTURERS_BY_SUBJECT,
                variables: {
                    subject_id: parseInt(subjectId),
                    institution_id: parseInt(Cookies.get("institution_id") || Cookies.get("institutionid") || "0")
                },
                fetchPolicy: "network-only"
            });
            if (res.data && res.data.getLecturersBySubject) {
                this.setState({ lecturersList: res.data.getLecturersBySubject });
            }
        } catch (error) {
            console.error("Error fetching lecturers:", error);
        }
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            this.handleRemoveFile();
            return;
        }

        // Validate strictly image-only
        if (!file.type.startsWith('image/')) {
            this.setState({
                file: null,
                fileError: 'Please upload image files only (PNG, JPG, etc.)',
                filePreviewUrl: ''
            });
            e.target.value = ''; // Reset file input
            return;
        }

        // Validate size (5MB limit)
        if (file.size > 5 * 1024 * 1024) {
            this.setState({
                file: null,
                fileError: 'Image size must be less than 5MB',
                filePreviewUrl: ''
            });
            e.target.value = ''; // Reset file input
            return;
        }

        this.setState({
            file: file,
            fileError: '',
            filePreviewUrl: URL.createObjectURL(file)
        });
    }

    handleRemoveFile = () => {
        if (this.state.filePreviewUrl) {
            URL.revokeObjectURL(this.state.filePreviewUrl);
        }
        this.setState({ file: null, filePreviewUrl: '', fileError: '' });
        if (this.fileInputRef) {
            this.fileInputRef.value = '';
        }
    }

    handleClear = () => {
        this.handleRemoveFile();
        this.setState({
            subject: '',
            chapter: '',
            assignedFacultyId: '',
            lecturersList: [],
            title: '',
            description: '',
            submitting: false,
            validated: false,
            errorMsg: '',
            successMsg: ''
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            this.setState({ validated: true });
            return;
        }

        // Validation for Description minimum length
        if (this.state.description.trim().length < 10) {
            this.setState({ errorMsg: 'Description must be at least 10 characters long.' });
            return;
        }

        this.setState({ submitting: true, errorMsg: '', successMsg: '' });

        try {
            let image_path = "";

            if (this.state.file) {
                const base64File = await this.getBase64(this.state.file);
                const uploadRes = await this.props.fileUpload({
                    variables: {
                        params: {
                            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                            category: "materials", // using generic materials folder
                            client_id: 1, // defaulting to 1 or pull from cookies
                            file: [
                                {
                                    img: base64File,
                                    filename: this.state.file.name
                                }
                            ]
                        }
                    }
                });

                if (uploadRes && uploadRes.data && uploadRes.data.fileUpload && uploadRes.data.fileUpload.length > 0) {
                    image_path = uploadRes.data.fileUpload[0].file_url;
                }
            }

            await this.props.createDoubt({
                variables: {
                    params: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                        title: this.state.title,
                        description: this.state.description,
                        subject: parseInt(this.state.subject),
                        chapter: this.state.chapter ? parseInt(this.state.chapter) : null,
                        name: Cookies.get("studentusername") || "",
                        image_path: image_path,
                        institution_id: parseInt(Cookies.get("institution_id") || Cookies.get("institutionid") || "0"),
                        assigned_faculty_id: this.state.assignedFacultyId ? parseInt(this.state.assignedFacultyId) : null,
                        estatus: 1
                    }
                }
            });

            this.setState({ successMsg: "Doubt submitted successfully!" });

            setTimeout(() => {
                this.handleClear();
                if (this.props.onDoubtCreated) {
                    this.props.onDoubtCreated();
                } else {
                    this.props.history.push('/student/doubts');
                }
            }, 1200);

        } catch (error) {
            console.error("Error submitting doubt:", error);
            this.setState({ errorMsg: "Error submitting doubt: " + error.message });
        } finally {
            this.setState({ submitting: false });
        }
    }

    render() {
        const subjects = this.props.getSubjects && this.props.getSubjects.getSubjects ? this.props.getSubjects.getSubjects : [];

        let filteredChapters = [];
        if (this.state.subject) {
            const selectedSub = subjects.find(s => s.id.toString() === this.state.subject.toString());
            if (selectedSub && selectedSub.studentChapters) {
                filteredChapters = selectedSub.studentChapters;
            }
        }

        return (
            <div className="dd-ask">
                <style>{`
                    .dd-ask {
                        --dd-accent:#4f6bed;
                        --dd-accent-dark:#1e80ce;
                        --dd-accent-tint:#eff6ff;
                        --dd-surface:#ffffff;
                        --dd-surface-alt:#f8fafc;
                        --dd-border:#e2e8f0;
                        --dd-border-strong:#cbd5e1;
                        --dd-text:#0f172a;
                        --dd-text-soft:#475569;
                        --dd-muted:#64748b;
                        --dd-faint:#94a3b8;
                        --dd-danger:#dc3545;
                        font-family:inherit;
                        color:var(--dd-text);
                    }

                    /* ---- section caption ---- */
                    .dd-ask .dd-caption {
                        font-size:.72rem;
                        font-weight:700;
                        letter-spacing:.5px;
                        text-transform:uppercase;
                        color:var(--dd-muted);
                        margin-bottom:16px;
                        display:flex;
                        align-items:center;
                        gap:10px;
                    }
                    .dd-ask .dd-caption::after {
                        content:'';
                        flex:1;
                        height:1px;
                        background:var(--dd-border);
                    }

                    /* ---- fields ---- */
                    .dd-ask .dd-field { margin-bottom:14px; }
                    .dd-ask .dd-label {
                        display:block;
                        font-size:.88rem;
                        font-weight:600;
                        color:var(--dd-text-soft);
                        margin-bottom:5px;
                    }
                    .dd-ask .dd-req { color:var(--dd-danger); }
                    .dd-ask .dd-input {
                        width:100% !important;
                        height:auto !important;
                        border:1px solid var(--dd-border-strong) !important;
                        border-radius:8px !important;
                        padding:10px 12px !important;
                        font-family:inherit !important;
                        font-size:.9rem !important;
                        line-height:1.5 !important;
                        background:var(--dd-surface) !important;
                        color:var(--dd-text) !important;
                        box-shadow:none !important;
                        transition:border-color .15s ease, box-shadow .15s ease;
                    }
                    .dd-ask .dd-input:focus {
                        outline:none !important;
                        border-color:var(--dd-accent) !important;
                        box-shadow:0 0 0 3px rgba(54,161,245,.15) !important;
                    }
                    .dd-ask .dd-input:disabled {
                        background:var(--dd-surface-alt) !important;
                        color:var(--dd-faint) !important;
                        cursor:not-allowed;
                    }
                    .dd-ask select.dd-input {
                        -webkit-appearance:none;
                        -moz-appearance:none;
                        appearance:none;
                        background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath fill='%2364748b' d='M1 1.5 6 6.5l5-5'/%3E%3C/svg%3E") !important;
                        background-repeat:no-repeat !important;
                        background-position:right 12px center !important;
                        background-size:11px 8px !important;
                        padding-right:32px !important;
                        cursor:pointer;
                    }
                    .dd-ask textarea.dd-input { min-height:110px; resize:vertical; }
                    .dd-ask .dd-count {
                        font-size:.75rem;
                        color:var(--dd-faint);
                        text-align:right;
                        margin-top:4px;
                    }
                    .dd-ask .dd-error {
                        font-size:.8rem;
                        color:var(--dd-danger);
                        margin-top:4px;
                        font-weight:600;
                    }

                    /* ---- notices ---- */
                    .dd-ask .dd-note {
                        font-size:.82rem;
                        font-weight:600;
                        line-height:1.45;
                        padding:11px 14px;
                        border-radius:8px;
                        border:1px solid;
                        margin-bottom:16px;
                    }
                    .dd-ask .dd-note-ok { color:#059669; border-color:#a7f3d0; background:#d1fae5; }
                    .dd-ask .dd-note-err { color:#dc3545; border-color:#f5c2c2; background:#fce8e8; }

                    /* ---- attachment ---- */
                    .dd-ask .dd-upload {
                        border:2px dashed var(--dd-border-strong);
                        border-radius:8px;
                        background:var(--dd-surface-alt);
                        padding:16px;
                        text-align:center;
                        transition:all .2s ease-in-out;
                    }
                    .dd-ask .dd-upload:hover {
                        border-color:var(--dd-accent);
                        background:var(--dd-accent-tint);
                    }
                    .dd-ask .dd-upload-glyph {
                        font-size:1.8rem;
                        color:var(--dd-muted);
                        line-height:1;
                        margin-bottom:8px;
                    }
                    .dd-ask .dd-upload-hint {
                        font-size:.75rem;
                        color:var(--dd-faint);
                        margin-top:8px;
                    }
                    .dd-ask .dd-preview {
                        max-width:100%;
                        max-height:160px;
                        object-fit:contain;
                        border-radius:6px;
                        border:1px solid var(--dd-border);
                        background:var(--dd-surface);
                    }
                    .dd-ask .dd-filename {
                        font-size:.78rem;
                        color:var(--dd-muted);
                        margin-top:8px;
                        word-break:break-all;
                    }

                    /* ---- buttons ---- */
                    .dd-ask .dd-btn {
                        font-family:inherit;
                        font-weight:700;
                        font-size:.85rem;
                        padding:9px 22px;
                        border-radius:20px;
                        border:none;
                        cursor:pointer;
                        transition:all .2s ease-in-out;
                    }
                    .dd-ask .dd-btn:disabled { opacity:.5; cursor:default; box-shadow:none; }
                    .dd-ask .dd-btn-ghost {
                        background:var(--dd-surface);
                        border:1px solid var(--dd-border-strong);
                        color:var(--dd-text-soft);
                    }
                    .dd-ask .dd-btn-ghost:hover:not(:disabled) { background:var(--dd-surface-alt); }
                    .dd-ask .dd-btn-primary {
                        background:linear-gradient(135deg,#4f6bed 0%,#1e80ce 100%);
                        color:#ffffff;
                        min-width:150px;
                        box-shadow:0 4px 14px rgba(54,161,245,.4);
                    }
                    .dd-ask .dd-btn-primary:hover:not(:disabled) {
                        transform:translateY(-2px);
                        box-shadow:0 6px 20px rgba(54,161,245,.5);
                        background:linear-gradient(135deg,#4cb0ff 0%,#2992e4 100%);
                    }
                    .dd-ask .dd-btn-chip {
                        background:var(--dd-surface);
                        border:1px solid var(--dd-accent);
                        color:var(--dd-accent);
                        font-size:.8rem;
                        padding:7px 18px;
                        border-radius:20px;
                        display:inline-block;
                    }
                    .dd-ask .dd-btn-chip:hover { background:var(--dd-accent-tint); }
                    .dd-ask .dd-btn-remove {
                        background:var(--dd-surface);
                        border:1px solid #dc3545;
                        color:#dc3545;
                        font-size:.75rem;
                        padding:5px 16px;
                        border-radius:20px;
                        margin-top:10px;
                    }
                    .dd-ask .dd-btn-remove:hover:not(:disabled) { background:#fce8e8; }

                    .dd-ask .dd-actions {
                        display:flex;
                        justify-content:flex-end;
                        gap:12px;
                        margin-top:22px;
                        padding-top:16px;
                        border-top:1px solid var(--dd-border);
                    }
                `}</style>

                <div className="dd-caption">Subject Query Register</div>

                {this.state.successMsg && (
                    <div className="dd-note dd-note-ok">{this.state.successMsg}</div>
                )}
                {this.state.errorMsg && (
                    <div className="dd-note dd-note-err">{this.state.errorMsg}</div>
                )}

                <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
                    <div className="dd-field">
                        <label className="dd-label" htmlFor="dd-subject">
                            Subject <span className="dd-req">*</span>
                        </label>
                        <select
                            id="dd-subject"
                            className="dd-input"
                            name="subject"
                            value={this.state.subject}
                            onChange={this.handleChange}
                            required
                            disabled={this.state.submitting}
                        >
                            <option value="">Select Subject</option>
                            {subjects && subjects.map(sub => (
                                <option key={sub.id} value={sub.id}>{sub.subject}</option>
                            ))}
                        </select>
                        {this.state.validated && !this.state.subject && (
                            <div className="dd-error">Please select a subject.</div>
                        )}
                    </div>

                    <div className="dd-field">
                        <label className="dd-label" htmlFor="dd-chapter">Chapter / Topic</label>
                        <select
                            id="dd-chapter"
                            className="dd-input"
                            name="chapter"
                            value={this.state.chapter}
                            onChange={this.handleChange}
                            disabled={!this.state.subject || this.state.submitting}
                        >
                            <option value="">Select Chapter</option>
                            {filteredChapters.map(ch => (
                                <option key={ch.id} value={ch.id}>{ch.chapter}</option>
                            ))}
                        </select>
                    </div>

                    <div className="dd-field">
                        <label className="dd-label" htmlFor="dd-lecturer">Lecturer (Optional)</label>
                        <select
                            id="dd-lecturer"
                            className="dd-input"
                            name="assignedFacultyId"
                            value={this.state.assignedFacultyId}
                            onChange={this.handleChange}
                            disabled={!this.state.subject || this.state.submitting}
                        >
                            <option value="">Select Lecturer</option>
                            {this.state.lecturersList.map(lecturer => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.employee_name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="dd-field">
                        <label className="dd-label" htmlFor="dd-title">
                            Title <span className="dd-req">*</span>
                        </label>
                        <input
                            id="dd-title"
                            className="dd-input"
                            type="text"
                            name="title"
                            placeholder="One line that names the doubt"
                            value={this.state.title}
                            onChange={this.handleChange}
                            required
                            maxLength={100}
                            disabled={this.state.submitting}
                        />
                        {this.state.validated && !this.state.title.trim() && (
                            <div className="dd-error">Please enter a title.</div>
                        )}
                        <div className="dd-count">{this.state.title.length} / 100</div>
                    </div>

                    <div className="dd-field">
                        <label className="dd-label" htmlFor="dd-description">
                            Your question <span className="dd-req">*</span>
                        </label>
                        <textarea
                            id="dd-description"
                            className="dd-input"
                            rows={4}
                            name="description"
                            placeholder="Type the doubt exactly as you'd ask your lecturer..."
                            value={this.state.description}
                            onChange={this.handleChange}
                            required
                            disabled={this.state.submitting}
                        />
                        {this.state.validated && this.state.description.trim().length < 10 && (
                            <div className="dd-error">Please describe your doubt (minimum 10 characters).</div>
                        )}
                    </div>

                    <div className="dd-field">
                        <label className="dd-label">Reference Image (Optional)</label>
                        <div className="dd-upload">
                            {this.state.filePreviewUrl ? (
                                <div>
                                    <img src={this.state.filePreviewUrl} alt="Preview" className="dd-preview" />
                                    <div className="dd-filename">{this.state.file ? this.state.file.name : ''}</div>
                                    <button
                                        type="button"
                                        className="dd-btn dd-btn-remove"
                                        onClick={this.handleRemoveFile}
                                        disabled={this.state.submitting}
                                    >
                                        Remove Image
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    <input
                                        type="file"
                                        name="file"
                                        accept="image/*"
                                        onChange={this.handleFileChange}
                                        ref={el => this.fileInputRef = el}
                                        style={{ display: 'none' }}
                                        id="upload-image-input"
                                        disabled={this.state.submitting}
                                    />
                                    <label htmlFor="upload-image-input" className="mb-0 w-100" style={{ cursor: 'pointer' }}>
                                        <div className="dd-upload-glyph">&#128247;</div>
                                        <span className="dd-btn dd-btn-chip">Attach Image</span>
                                        <div className="dd-upload-hint">PNG / JPG / JPEG &middot; max 5MB</div>
                                    </label>
                                </div>
                            )}
                            {this.state.fileError && (
                                <div className="dd-error">{this.state.fileError}</div>
                            )}
                        </div>
                    </div>

                    <div className="dd-actions">
                        <button
                            type="button"
                            className="dd-btn dd-btn-ghost"
                            onClick={this.props.onCancel || this.handleClear}
                            disabled={this.state.submitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="dd-btn dd-btn-primary"
                            disabled={this.state.submitting || !!this.state.fileError}
                        >
                            {this.state.submitting ? (
                                <>
                                    <Spinner animation="border" size="sm" className="mr-2" />
                                    Submitting...
                                </>
                            ) : 'Submit doubt'}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }
}

export default compose(
    withRouter,
    withApollo,
    graphql(FETCH_GET_SUBJECTS, {
        options: () => ({
            variables: { student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")) || "" },
            fetchPolicy: "cache-and-network"
        }),
        name: "getSubjects"
    }),
    graphql(CREATE_DOUBT_MUTATION, {
        name: "createDoubt"
    }),
    graphql(FILE_UPLOAD_MUTATION, {
        name: "fileUpload"
    })
)(CreateDoubtForm);
